import React, { useState } from "react";
import { DocModal } from "./DocModal";
import { LysaLinkButton } from "../lysaLink/LysaLinkButton";
export const DocModalLink = ({ document, modalAnnouncement, variableValues, children, appElement, className, component, }) => {
    const [active, setActive] = useState(false);
    const Component = component || LysaLinkButton;
    return (React.createElement("span", { className: className },
        React.createElement(DocModal, { active: active, onRequestClose: () => setActive(false), docList: [document], modalAnnouncement: modalAnnouncement, appElement: appElement, variableValues: variableValues }),
        React.createElement(Component, { onClick: () => setActive(true) }, children)));
};
